import { MainColor } from '../../../palette/colors';

export const getMultipleActionsListItem = () => {
  return {
    defaultState: {
      primaryTextColor: 'navy95' satisfies MainColor as MainColor,
      secondaryTextColor: 'coolGrey60' satisfies MainColor as MainColor,
      svgColor: 'navy80' satisfies MainColor as MainColor,
      backgroundColor: 'coolGrey5' satisfies MainColor as MainColor,
      borderColor: 'coolGrey10' satisfies MainColor as MainColor,
    },
    hover: {
      backgroundColor: 'navy10' satisfies MainColor as MainColor,
    },
    selected: {
      backgroundColor: 'navy10' satisfies MainColor as MainColor,
      checkmark: {
        backgroundColor: 'forest10' satisfies MainColor as MainColor,
        color: 'forest50' satisfies MainColor as MainColor,
      },
    },
  };
};

export type MultipleActionsListItem = ReturnType<typeof getMultipleActionsListItem>;
